import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { loginUser } from "../auth/authLoginSlice";

// initial state
export const initialState = {
  loading: false,
  loadingQuoteSummary: false,
  error: null,
  errorMessage: null,
  success: false,
  quoteSummarySuccess: false,
  QuoteNotehistory: null,
  QuoteHistoryDetails: null,
  username: null,
  QuoteResponse: {
    Quoteid: 0,
    QuoteNumber: "",
  },
  EditQuoteDetails: null,
  PlaceOrderFileNumber: null,
  QuoteInvoiceDetails: null,
  ValidQuote: true,
};

// our slice
const quoteSlice = createSlice({
  name: "quote",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setLoadingQuoteSummary: (state) => {
      state.loadingQuoteSummary = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
      state.loadingQuoteSummary = false;
    },
    setErrorMessage: (state, { payload }) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setQuoteSummarySuccess: (state, payload) => {
      state.loading = false;
      state.error = false;
      state.quoteSummarySuccess = payload;
    },
    setQuoteResponse: (state, { payload }) => {
      state.QuoteResponse.Quoteid = payload.quoteId;
      state.QuoteResponse.QuoteNumber = payload.quoteNumber;
    },
    setEditQuoteDetails: (state, { payload }) => {
      state.loadingQuoteSummary = false;
      state.EditQuoteDetails = payload;
      state.QuoteInvoiceDetails = payload.cticQuoteInvoiceResponse;
    },
    setQuoteNotehistory: (state, { payload }) => {
      state.QuoteNotehistory = payload;
    },
    setQuoteHistoryDetails: (state, { payload }) => {
      state.QuoteHistoryDetails = payload;
    },
    setQuotePlaceOrderFileNumber: (state, { payload }) => {
      state.PlaceOrderFileNumber = payload;
    },
    setValidQuote: (state, { payload }) => {
      state.ValidQuote = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setErrorMessage,
  setSuccess,
  setQuoteResponse,
  setEditQuoteDetails,
  setQuoteSummarySuccess,
  setQuoteNotehistory,
  setQuoteHistoryDetails,
  setQuotePlaceOrderFileNumber,
  setLoadingQuoteSummary,
  setValidQuote,
} = quoteSlice.actions;

export const quoteSelector = (state) => state.quote;

const getQuoteBooleanQtnAnswValue = (answerValue) => {
  var returnValue = null;
  if (answerValue === null || answerValue === undefined || answerValue === "") {
    returnValue = null;
  } else if (
    answerValue.toLowerCase() === "yes" ||
    answerValue.toLowerCase() === "true"
  ) {
    returnValue = true;
  } else {
    returnValue = false;
  }

  return returnValue;
};

// export the default reducer
export default quoteSlice.reducer;

// Quote Insert
export const InsertQuoteData =
  (QuoteData, userid, lang) => async (dispatch) => {
    try {
      dispatch(setLoading());
      var QuoteProperties = [];
      var QuoteMortgagors = [];
      var QuoteEndorsements = [];
      QuoteData.QuoteProperty.forEach((element, index) => {
        QuoteProperties.push({
          PropertyID: parseInt(element.PropertyID),
          AddtnPropClosingDate:
            element.AddtnPropClosingDate === undefined ||
            element.AddtnPropClosingDate === "" ||
            element.AddtnPropClosingDate <= new Date(Date.UTC(1900, 0, 1))
              ? null
              : new Date(element.AddtnPropClosingDate),
          AddtnPropPurchasePrice:
            element.AddtnPropPurchasePrice === undefined ||
            element.AddtnPropPurchasePrice === ""
              ? null
              : Number.parseFloat(element.AddtnPropPurchasePrice).toFixed(2),
          isExistingOwnerPolicy: getQuoteBooleanQtnAnswValue(
            element.EOPRequired,
          ),
          MortgagorsPurchasingProp: getQuoteBooleanQtnAnswValue(
            element.MtgPurchasingPropRefi,
          ),
          OriginalPurchaseAssessedPrice:
            element.OriginalPurchPriceEHOP === undefined ||
            element.OriginalPurchPriceEHOP === ""
              ? null
              : Number.parseFloat(element.OriginalPurchPriceEHOP).toFixed(2),
          isPropertyAggregate: getQuoteBooleanQtnAnswValue(
            element.PropertyAggregate,
          ),
          PropertyType: element.PropertyType,
          isPurchase: getQuoteBooleanQtnAnswValue(element.TransPurchase),
          ClosingDate:
            element.closingDate === undefined ||
            element.closingDate === "" ||
            element.closingDate <= new Date(Date.UTC(1900, 0, 1))
              ? null
              : new Date(element.closingDate),
          OriginalTransferDate:
            element.OriginalTransferDate === undefined ||
            element.OriginalTransferDate === "" ||
            element.OriginalTransferDate <= new Date(Date.UTC(1900, 0, 1))
              ? null
              : new Date(element.OriginalTransferDate),
          isIPAOwner: getQuoteBooleanQtnAnswValue(
            element.increasedPolicyQuestion,
          ),
          isIndigenousLand: getQuoteBooleanQtnAnswValue(
            element.indigenousQuestion,
          ),
          //element.isClosingDateNotDecided,
          isOwnerPolicy: getQuoteBooleanQtnAnswValue(element.ownerPolicy),
          PurchasePrice:
            index === 0
              ? element.purchasePrice === undefined ||
                element.purchasePrice === ""
                ? null
                : Number.parseFloat(element.purchasePrice).toFixed(2)
              : !getQuoteBooleanQtnAnswValue(element.PropertyAggregate)
                ? element.PropertyPurchasePrice === undefined ||
                  element.PropertyPurchasePrice === ""
                  ? null
                  : Number.parseFloat(element.PropertyPurchasePrice)
                : element.purchasePrice === undefined ||
                    element.purchasePrice === ""
                  ? null
                  : Number.parseFloat(element.purchasePrice),
          ExchangeRateProp: element?.exchangerateprop || "",
          PurchasePriceUSD: element.purchasepriceusd || -1,
          AppraisedValueUSD: element.appraisedvalueusd || -1,
          PowerOfSale: getQuoteBooleanQtnAnswValue(element.powerofsale),
          isTPEOwner: getQuoteBooleanQtnAnswValue(
            element.transactionProtectionOwner,
          ),
          ConstructionQuestion: getQuoteBooleanQtnAnswValue(element.ConstructionQuestion),
        });
      });

      QuoteData?.QuoteMortgage?.forEach((element) => {
        var QuoteMtgPropPriority = [];
        element?.LenderInfoProperty?.forEach((item) => {
          QuoteMtgPropPriority.push({
            //  MortgagorID:parseInt(element.MortgagorID),
            PropertyID:
              item.property === undefined ? null : parseInt(item.property),
            Priority:
              item.priority === undefined ? null : parseInt(item.priority),
          });
        });
        QuoteMortgagors.push({
          MortgagorID: parseInt(element.MortgagorID),
          Priority:
            element.IndicatePriorityMtg === undefined
              ? null
              : parseInt(element.IndicatePriorityMtg),
          LenderID: parseInt(element.Lender),
          isLoanPolicy: getQuoteBooleanQtnAnswValue(element.LoanPolicyRequired),
          isMtgPriorityRequired: getQuoteBooleanQtnAnswValue(
            element.MtgPriorityReqLender,
          ),
          isSPELender: getQuoteBooleanQtnAnswValue(element.SPELender),
          isTPELender: getQuoteBooleanQtnAnswValue(element.TPELender),
          isConstructionLoan: getQuoteBooleanQtnAnswValue(
            element.ConstructionLoan,
          ),
          isEncroachment: getQuoteBooleanQtnAnswValue(
            element.EncroachmentWorkOrder,
          ),
          MortgageAmount:
            element.mortgage_amount === "" ||
            element.mortgage_amount === undefined ||
            element.mortgage_amount === NaN
              ? 0
              : Number.parseFloat(element.mortgage_amount).toFixed(2),
          TypeOfMortgage: parseInt(element.typeOfMtg),
          QuoteMtgPropPriority:
            QuoteMtgPropPriority === undefined ? "" : QuoteMtgPropPriority,
        });
      });

      var PrivateBaseInfo = {
        LawyerID:
          QuoteData.lawyerornotaryofrecord === undefined
            ? -1
            : parseInt(QuoteData.lawyerornotaryofrecord),
        OrderingLawyerID:
          QuoteData.orderinglawyerornotary === undefined
            ? -1
            : parseInt(QuoteData.orderinglawyerornotary),
        AssistantID:
          QuoteData.assistant === undefined || QuoteData.assistant === ""
            ? -1
            : parseInt(QuoteData.assistant),
        FileReferenceNumber:
          QuoteData.fileorreferencenumber === undefined
            ? ""
            : QuoteData.fileorreferencenumber,
        ProgramCodeUsed: getQuoteBooleanQtnAnswValue(
          QuoteData.programcodeusedfororde,
        ),
        ProgramCode: QuoteData?.programcode || "",
        LenderCode: QuoteData?.lendercode || "",
        DealType: QuoteData.dealtype === undefined ? "" : QuoteData.dealtype,
        Province:
          QuoteData.propertyLocated === undefined
            ? ""
            : QuoteData.propertyLocated,
        QuoteProperties: QuoteProperties,
        OfficeLocation: QuoteData?.officelocation || -1,
        ProjectName: QuoteData?.projectname || "",
        PreferredLanguage: QuoteData?.preferredlanguage || "",
      };

      var PublicBaseInfo = {
        LawyerName:
          QuoteData.lawyerName === undefined ? "" : QuoteData.lawyerName,
        LawfirmName:
          QuoteData.lawfirmName === undefined ? "" : QuoteData.lawfirmName,
        PhoneNumber:
          QuoteData.phone_number === undefined ? "" : QuoteData.phone_number,
        Email: QuoteData.email === undefined ? "" : QuoteData.email,
        PreferredLanguage:
          QuoteData.languageType === undefined ? "" : QuoteData.languageType,
        DealType:
          QuoteData.PublicdealType === undefined
            ? ""
            : QuoteData.PublicdealType,
        Province:
          QuoteData.PropertyLocatedDropdown === undefined
            ? ""
            : QuoteData.PropertyLocatedDropdown,
      };

      QuoteData?.QuoteEndorsements?.forEach((element) => {
        if (
          element.EndorsementotherName !== undefined &&
          element.EndorsementotherName !== ""
        )
          QuoteEndorsements.push({
            EndorsementName: element.EndorsementotherName,
            EndorsementFee: element.EndorsementotherFee,
          });
      });

      var reqData = {
        QuoteId: parseInt(QuoteData.QuoteId),
        PrivateBaseInfo: PrivateBaseInfo,
        PublicBaseInfo: PublicBaseInfo,
        QuoteProperties: QuoteProperties,
        QuoteMortgagors: QuoteMortgagors,
        QuoteEndorsements: QuoteEndorsements,
        isPublic: QuoteData.UserLoginExists ? false : true,
        EditReason:
          QuoteData.QuoteAddtnInfoEditReason === undefined ||
          QuoteData.QuoteAddtnInfoEditReason === null
            ? ""
            : QuoteData.QuoteAddtnInfoEditReason,
        UserID:
          QuoteData.UserID === null ||
          QuoteData.UserID === undefined ||
          QuoteData.UserID === ""
            ? -1
            : QuoteData.UserID,
        OrderDiscount: getQuoteBooleanQtnAnswValue(QuoteData?.orderdiscount),
        DiscountType: QuoteData?.QuoteEndorsements?.DiscountType || "",
        DiscountValue: QuoteData?.QuoteEndorsements?.DiscountValue || -1,
        DiscountReason: QuoteData?.QuoteEndorsements?.DiscountReason || "",
        Notes: QuoteData?.QuoteEndorsements?.notes,
      };
      dispatch(setValidQuote(true));
      // Make API call for Save Quote Details
      const { data: response } = await http.post(
        "Quote/SaveQuoteDetails",
        reqData,
      );
      if (response.responseCode == 0) {
        const { data: responseQuote } = await http.post(
          "Quote/GetQuoteDetails",
          {
            QuoteId: response?.responseObject?.quoteId,
            Lang: lang,
            UserID: userid,
          },
        );

        if (responseQuote?.responseObject?.cticQuoteInvoiceResponse === null) {
          dispatch(setValidQuote(false));
          dispatch(setError(false));
        } else {
          dispatch(setQuoteSummarySuccess(true));
          dispatch(setQuoteResponse(response.responseObject));
          dispatch(setError(false));
          dispatch(setErrorMessage(null));
        }
      } else {
        if (response.responseCode == -2) {
          dispatch(setError("-2"));
        } else if (response.responseCode == -10) {
          dispatch(setError(response.responseCode));
          dispatch(setErrorMessage(response.error[0].errorMessage));
        } else {
          dispatch(setError(response.responseDescription));
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
export const SetQuoteSummarySuccess = (val) => async (dispatch) => {
  dispatch(setQuoteSummarySuccess(val));
};
export const GetQuoteDetails = (QuoteID, UserID, lang) => async (dispatch) => {
  try {
    dispatch(setLoadingQuoteSummary());
    var reqData = {
      QuoteId: QuoteID,
      Lang: lang,
      UserID: UserID,
    };
    const { data: response } = await http.post(
      "Quote/GetQuoteDetails",
      reqData,
    );
    if (response.responseCode == 0) {
      dispatch(setEditQuoteDetails(response.responseObject));
      dispatch(setSuccess());
    } else {
      if (response.responseCode == -2) {
        dispatch(setError("-2"));
      } else {
        dispatch(setError(response.responseDescription));
      }
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetQuoteNoteHistory = (QuoteID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    var reqData = {
      QuoteId: parseInt(QuoteID),
    };
    const { data: response } = await http.post(
      "Quote/GetQuoteNoteHistory",
      reqData,
    );
    if (response.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(setQuoteNotehistory(response.responseObject));
    } else {
      if (response.responseCode == -2) {
        dispatch(setError("-2"));
        dispatch(setQuoteNotehistory(null));
      } else {
        dispatch(setError(response.responseDescription));
        dispatch(setQuoteNotehistory(null));
      }
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
    dispatch(setQuoteNotehistory(null));
  }
};
export const GetQuoteHistory =
  (
    QuoteID,
    LawyerID,
    AssistantID,
    DealType,
    QuoteReferencePropertyType,
    userID,
  ) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      var reqData = {
        QuoteId: parseInt(QuoteID),
        LawyerIDFilter: parseInt(LawyerID),
        AssistantIDFilter: parseInt(AssistantID),
        DealTypeFilter: DealType,
        QuoteReferencePropertyTypeFilter: QuoteReferencePropertyType,
        UserID: parseInt(userID),
      };
      const { data: response } = await http.post(
        "Quote/GetQuoteHstory",
        reqData,
      );
      if (response.responseCode == 0) {
        dispatch(setSuccess());
        dispatch(
          setQuoteHistoryDetails(response.responseObject.quoteHistoryDetails),
        );
      } else {
        if (response.responseCode == -2) {
          dispatch(setError("-2"));
          dispatch(setQuoteHistoryDetails(null));
        } else {
          dispatch(setError(response.responseDescription));
          dispatch(setQuoteHistoryDetails(null));
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
      dispatch(setQuoteHistoryDetails(null));
    }
  };

export const QuotePlaceOrder = (QuoteID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    var reqData = {
      QuoteId: parseInt(QuoteID),
    };
    const { data: response } = await http.post(
      "Quote/QuotePlaceOrder",
      reqData,
    );
    if (response.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(
        setQuotePlaceOrderFileNumber(response.responseObject.fileNumber),
      );
    } else {
      if (response.responseCode == -2) {
        dispatch(setError("-2"));
        dispatch(setQuotePlaceOrderFileNumber(null));
      } else {
        dispatch(setError(response.responseDescription));
        dispatch(setQuotePlaceOrderFileNumber(null));
      }
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
    dispatch(setQuotePlaceOrderFileNumber(null));
  }
};

export const SendEmailForQuoteInvoice =
  (req, { toast }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      let data = { UserID: req.UserID, RequestObject: req };
      const results = await http
        .post("Quote/SendEmailForQuoteInvoice", data)
        .then((result) => {
          return result;
        });

      if (results.data.responseObject.isSuccess) {
        dispatch(setSuccess());
        toast("Email sent successfully!", { type: "success" });
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
